import localstorage from '@/store/localstorage';
import Vue from 'vue';

class Identity {
  Token?: '';
  Identifier?: '';
}

const socket = new WebSocket('wss://prod.aeroguest.io:39286');
// const userData: any = { token: localstorage.GetToken(), userId: localstorage.GetVGUserInJsonParse()?.UserId, phoneNumber: localstorage.GetwebCheckInfo().PhoneNumber };
const userData: any = { token: localstorage.GetToken() };
const userIdentity: Identity = localstorage.GetIdentifier() !== null ? localstorage.GetIdentifier() : '';

const options: any = {
  Token: userData.token,
  Type: 'Support',
  // PhoneNumber: userData.phoneNumber,
  PhoneNumber: '',
  // UserId: userData.userId,
  Context: 'web',
  // DeviceId: 'web'
  DeviceId: `token:${userIdentity.Token}/identifier:${userIdentity.Identifier}`

};

const emitter = new Vue({
  methods: {
    send (message: any) {
      if (socket.readyState === 1) {
        socket.send(message);
      }
    }
  }
});

socket.onmessage = function (msg) {
  const message = JSON.parse(msg.data);
  emitter.$emit('message', message);
};

socket.onerror = function (err) {
  emitter.$emit('error', err);
};

socket.onopen = () => {
  socket.send(JSON.stringify(options));
};

export default emitter;
